import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import "./LoadingBackdrop.css";
export default function LoadingBackdrop() {
  return <div>      
      <Backdrop sx={theme => ({
      color: '#fff',
      zIndex: theme.zIndex.drawer + 1
    })} open={true}>
        <div className="migrated-style-loadingbackdrop-e2432c-1">
            <CircularProgress color="inherit" />      
            <div>Loading preview. This may take a few seconds.</div>
        </div>        
      </Backdrop>
    </div>;
}
